import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();

const logChartmindDDXDiagnosticFn = httpsCallable(
  functions,
  "logChartmindDDXDiagnostic",
  { timeout: 15000 }
);

const MAX_PREVIEW = 4000;

/**
 * Sends a diagnostic record to Cloud Functions (stdout → Cloud Logging).
 * Fire-and-forget; failures are swallowed after console.error.
 */
export function logChartmindDDXDiagnostic({
  event,
  responseText,
  organizationId,
  transcriptLength,
}) {
  let responsePreview =
    typeof responseText === "string" ? responseText : "";
  if (responsePreview.length > MAX_PREVIEW) {
    responsePreview = `${responsePreview.slice(0, MAX_PREVIEW)}…[truncated]`;
  }

  logChartmindDDXDiagnosticFn({
    event,
    responsePreview,
    organizationId:
      typeof organizationId === "string" && organizationId.trim()
        ? organizationId.trim()
        : null,
    transcriptLength:
      typeof transcriptLength === "number" && Number.isFinite(transcriptLength)
        ? transcriptLength
        : null,
  }).catch((err) => {
    console.error("[chartmindDDXDiagnosticLog] Callable failed:", err);
  });
}
